import React from "react";
import { QualityController } from "./QualityController";
import { QualityViewModel } from "./QualityViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class QualityProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new QualityViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <QualityController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Quality/QualityProvider.js